export const homePageBreadcrumbs = {
  link: '/#/',
  text: 'Главная',
  onClick: () => {
    document.location.assign('/#/');
  },
};

export const adminPageBreadcrumbs = {
  link: '/#/ac',
  onClick: () => {
    document.location.assign('/#/ac');
  },
  text: 'Администрирование',
};

export const catalogsPageBreadcrumbs = {
  link: '/#/catalogs',
  onClick: () => {
    document.location.assign('/#/catalogs');
  },
  text: 'Справочники',
};
